export default async function fetchWithTimeout(url, options = {}, timeout = 10000) {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id) // Clear the timeout if the fetch completes successfully

    return response
  } catch (error) {
    clearTimeout(id) // Clear the timeout even if an error occurs
    if (error.name === 'AbortError') {
      console.error('Fetch request timed out for URL:', url)
      // You can throw a custom error or handle it as needed
      throw new Error('Request timed out')
    }
    throw error
  }
}
